import { combineReducers } from 'redux'
import {
	newsSlice,
	ratingSlice,
	notificationListSlice,
	deviceSlice,
	dictsSlice,
	notificationPopupSlice,
	taskSlice,
	selectSlice,
	notifySlice,
	modalsSlice,
	fmsSlice,
	mainMenuSlice,
	sortingSlice,
	filtersSlice,
	feedbackModalSlice,
	sberOprosSlice,
	dadataSlice,
	emailSlice,
	fileSlice,
	feedbackWidgetSlice,
	loadersSlice,
	formsSlice,
	gridSlice,
	reportSlice,
	settingSlice,
	regionByIpSlice,
	userSettingSlice,
} from 'Modules'
import { socketSlice } from 'Modules/Socket'
import { headerReportSlice } from 'Modules/HeaderReport'

export const modules = combineReducers({
	[notificationListSlice.name]: notificationListSlice.reducer,
	[ratingSlice.name]: ratingSlice.reducer,
	[newsSlice.name]: newsSlice.reducer,
	[deviceSlice.name]: deviceSlice.reducer,
	[dictsSlice.name]: dictsSlice.reducer,
	[taskSlice.name]: taskSlice.reducer,
	[notificationPopupSlice.name]: notificationPopupSlice.reducer,
	[selectSlice.name]: selectSlice.reducer,
	[modalsSlice.name]: modalsSlice.reducer,
	[socketSlice.name]: socketSlice.reducer,
	[notifySlice.name]: notifySlice.reducer,
	[fmsSlice.name]: fmsSlice.reducer,
	[mainMenuSlice.name]: mainMenuSlice.reducer,
	[sortingSlice.name]: sortingSlice.reducer,
	[filtersSlice.name]: filtersSlice.reducer,
	[feedbackModalSlice.name]: feedbackModalSlice.reducer,
	[sberOprosSlice.name]: sberOprosSlice.reducer,
	[dadataSlice.name]: dadataSlice.reducer,
	[emailSlice.name]: emailSlice.reducer,
	[fileSlice.name]: fileSlice.reducer,
	[feedbackWidgetSlice.name]: feedbackWidgetSlice.reducer,
	[formsSlice.name]: formsSlice.reducer,
	[loadersSlice.name]: loadersSlice.reducer,
	[gridSlice.name]: gridSlice.reducer,
	[reportSlice.name]: reportSlice.reducer,
	[settingSlice.name]: settingSlice.reducer,
	[regionByIpSlice.name]: regionByIpSlice.reducer,
	[headerReportSlice.name]: headerReportSlice.reducer,
	[userSettingSlice.name]: userSettingSlice.reducer,
})
